var map = {
	"./black/quxiaojingyin2.png": "0IQq",
	"./blue/quxiaojingyin2.png": "M56/",
	"./white/quxiaojingyin2.png": "dnwj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ezTo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/quxiaojingyin2\.png$
// module id = ezTo
// module chunks = 24